const PIGGY_BACK_CACHE_TIMEOUT = 1000;

function defaultCacheKeyAccessor( ...args ) {
	return JSON.stringify( args );
}

/*
	This allows us to "piggy-back" two or more identical API requests onto just one request where
	both callers execute as if they were the only request, but we're eliminating duplicate traffic, etc.
*/
export function piggyBack( original, { timeout = PIGGY_BACK_CACHE_TIMEOUT, getCacheKey = defaultCacheKeyAccessor, } = {} ) {
	if ( typeof original !== "function" ) {
		throw new Error( "piggyBack's first arg should be a function, or a calzone" );
	}

	const cache = new Map();

	return function( ...args ) {
		const key = getCacheKey( ...args );

		if ( !cache.has( key ) ) {
			cache.set( key, original( ...args ) );
			setTimeout( () => {
				cache.delete( key );
			}, timeout );
		}

		return cache.get( key );
	};
}
